"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PegaPal__factory = void 0;
const ethers_1 = require("ethers");
class PegaPal__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_pegaAddress, _minter, _auctionCap, _totalCap, overrides) {
        return super.deploy(_pegaAddress, _minter, _auctionCap, _totalCap, overrides || {});
    }
    getDeployTransaction(_pegaAddress, _minter, _auctionCap, _totalCap, overrides) {
        return super.getDeployTransaction(_pegaAddress, _minter, _auctionCap, _totalCap, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PegaPal__factory = PegaPal__factory;
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_pegaAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_auctionCap",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_totalCap",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "numLevels",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "LevelUp",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "NFTMinted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "PegaPalBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "PegaPalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "auctionCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "auctionMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseuri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "pegasusId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "baseNFT",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "fodderNFT",
                type: "uint256",
            },
        ],
        name: "fuseNFT",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "level",
                type: "uint256",
            },
        ],
        name: "levelURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "numLevels",
                type: "uint256",
            },
        ],
        name: "levelUp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mintingPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mintingTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pegaAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newAuctionCap",
                type: "uint256",
            },
        ],
        name: "setAuctionCap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newBaseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "level",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "newLevelURI",
                type: "string",
            },
        ],
        name: "setLevelURI",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newMintPrice",
                type: "uint256",
            },
        ],
        name: "setMintingPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_mintingTokenAddress",
                type: "address",
            },
        ],
        name: "setMintingToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newCap",
                type: "uint256",
            },
        ],
        name: "setTotalCap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newUpgradePrice",
                type: "uint256",
            },
        ],
        name: "setUpgradePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "tokenIdToLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenMintNFT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalPegaValue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "upgradePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
